import { createSlice } from "@reduxjs/toolkit";

export const StateMasterList = createSlice({
  name: "StateMasterList",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    data: [],
  },
  reducers: {
    list_state_master: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_list_state_master: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
    },
    failure_api_call_list_state_master: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    list_state_master_is_first: (state, action) => {
      state.isFirst = false;
    },
  },
});
export default StateMasterList.reducer;
export const {
  list_state_master,
  success_api_call_list_state_master,
  failure_api_call_list_state_master,
  list_state_master_is_first,
} = StateMasterList.actions;
